import styled from "styled-components";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ChartContainer = styled(FlexColumn)<{ cursorUrl: string }>`
    gap: 24px;
    &:hover {
        cursor: url(${({ cursorUrl }) => cursorUrl}), zoom-in;
    }
    .highcharts-axis-labels {
        cursor: default;
    }
`;
const ScatterLayout = styled(FlexColumn)`
    padding: 16px 24px;
    gap: 24px;
`;

export const ScatterContent = styled(FlexRow)`
    gap: 24px;
    width: 100%;
`;

export const ScatterWrapper = styled.div`
    flex: 1;
    min-width: 0;
`;
